import _classCallCheck from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import Card from "./card.js";
var ControlCard = /*#__PURE__*/function (_Card) {
  _inherits(ControlCard, _Card);
  var _super = _createSuper(ControlCard);
  function ControlCard(t, s, l, i, r, n) {
    var _this;
    _classCallCheck(this, ControlCard);
    _this = _super.call(this, t, s, null, null, null, l, i, null, null, null, r, n), _this.isControl = !0, _this.Xt = "ab-control-card", _this.Yt = !1;
    return _this;
  }
  _createClass(ControlCard, [{
    key: "dt",
    value: function dt() {
      var t = {};
      return t[Card.ss.ts] = Card.es.Ni, t[Card.ss.rs] = this.id, t[Card.ss.os] = this.viewed, t[Card.ss.ps] = this.updated, t[Card.ss.us] = this.expiresAt, t[Card.ss.xs] = this.extras, t[Card.ss.bs] = this.pinned, t[Card.ss.qs] = this.test, t;
    }
  }]);
  return ControlCard;
}(Card);
export { ControlCard as default };